import React, { useState, useEffect } from "react";
import {
  FaChevronUp
} from "react-icons/fa";

import switchImg from "../images/switch2.jpg";
import module from "../images/module.jpg";
import camera from "../images/smartcameras.jpg";
import R from "../images/R.jpg";
import Thermostat from "../images/Thermostat.png";
import Sensor from "../images/Sensor.png";
import Gate from "../images/SmartControll.png";
import led from "../images/smartled.avif";
import voice from "../images/voice.webp";
import lock from "../images/Lock.webp";

const products = [
  { title: "Smart Switches", description: "Smart Lightning Switch, Smart Shutter Switch, Smart Curtain Switch, Smart Boiler Switch, Etc.", image: switchImg },
  { title: "Smart Modules", description: "Smart Lightning Module, Smart Shutter Module, Smart Dimmer Module, Smart Garage Opener, Etc.", image: module },
  { title: "Smart Curtains", description: "Splicing Curtain Motor, Roller Blinds Curtain, Chain Roller Motor.", image: R },
  { title: "Smart Thermostats", description: "Smart AC Thermostat, Smart Underfloor Thermostat, Etc.", image: Thermostat },
  { title: "Smart Sensors", description: "Smart Motion Sensor, Smart Window Sensor, Smart Vibration Sensor, Smart Gas Sensor, Etc.", image: Sensor },
  { title: "Smart Cameras", description: "Smart Outdoor Cameras, Smart Indoor Cameras.", image: camera },
  { title: "Smart Voice Assistance", description: "Alexa, Google, Homepod, Etc.", image: voice },
  { title: "Smart Locks", description: "Smart Door Lock, Smart Glass Door Lock, Smart Gate Lock.", image: lock },
  { title: "Smart Control", description: "Smart Gateway, Smart Remote, Smart Universal, Etc.", image: Gate },
  { title: "Smart Lightning", description: "Smart Led Strip, Smart Bulb Light, Smart Projector, Smart Spots, Etc.", image: led },
];

export default function OurProducts() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section style={{ padding: "4rem 2rem", maxWidth: 1200, margin: "0 auto", backgroundColor: "#fff" }}>
      <h1 style={{
        fontSize: "3rem",
        fontWeight: "800",
        textAlign: "center",
        marginBottom: "3rem",
        color: "#222",
        borderBottom: "4px solid #eee",
        paddingBottom: "1rem"
      }}>
        Our Products
      </h1>

      <div style={{ display: "flex", flexDirection: "column", gap: "3rem" }}>
        {products.map(({ title, description, image }, idx) => (
          <div
            key={idx}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "2rem",
              paddingBottom: "2rem",
              borderBottom: idx !== products.length - 1 ? "1px solid #eee" : "none",
              transition: "all 0.3s ease",
              borderRadius: "12px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.03)",
            }}
          >
            <img
              src={image}
              alt={title}
              loading="lazy"
              style={{
                width: 220,
                height: 160,
                objectFit: "cover",
                borderRadius: "12px",
                flexShrink: 0,
                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 6px 20px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "0 4px 15px rgba(0,0,0,0.1)";
              }}
            />
            <div>
              <h2 style={{ margin: "0 0 0.5rem 0", fontWeight: 700, fontSize: "1.6rem", color: "#111" }}>
                {title}
              </h2>
              <p style={{ margin: 0, color: "#555", fontSize: "1.05rem", lineHeight: 1.6 }}>
                {description}
              </p>
            </div>
          </div>
        ))}
      </div>

      {showButton && (
        <button
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: '40px',
            left: '25px',
            width: '45px',
            height: '45px',
            borderRadius: '50%',
            backgroundColor: '#333',
            color: '#fff',
            border: 'none',
            fontSize: '20px',
            fontWeight: 'bold',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
            cursor: 'pointer',
            zIndex: 999,
            transition: 'opacity 0.3s ease, transform 0.3s ease',
          }}
        >
          <FaChevronUp />
        </button>
      )}

      <style>{`
        @media (max-width: 768px) {
          section {
            padding: 2rem 1rem !important;
          }
          div[style*="flex-direction: column"] > div {
            flex-direction: column !important;
            align-items: flex-start !important;
          }
          div[style*="flex-direction: column"] > div img {
            width: 100% !important;
            height: auto !important;
            margin-bottom: 1rem;
          }
        }
      `}</style>
    </section>
  );
}
